import { TheNewHeader } from "../fileHeader.js";
import { getDataShape } from "./getDataShape.js";
/**
 * Inspects properties and tries to classify the spectra for the most common spectra types.
 * @param meta - the parsed file header.
 * @returns string describing the type of spectra or "General" if unsure.
 */
export function guessSpectraType(meta) {
    //function tested with the `fileHeader.test.ts`
    // for the new file header they define a "experiment type"
    if (meta instanceof TheNewHeader && // "General SPC" does not give any information
        !meta.experimentType.startsWith('General SPC')) {
        const id = meta.experimentType.split(' ')[0];
        switch (id //find all possible ids in `types.ts` file
        ) {
            case 'FT-IR,':
                return 'ir';
            case 'NIR':
                return 'ir';
            case 'UV-VIS':
                return 'uv';
            case 'Mass':
                return 'mass';
            case 'Raman':
                return 'raman';
            default:
                return 'other';
        }
    }
    // for old header or General SPC
    switch (meta.xUnitsType) {
        case 'Mass (M/z)':
            return 'mass';
        case 'Raman Shift (cm-1)':
            return 'raman';
        case 'Micrometers (um)':
            return uvOrIR(meta, 'micrometer');
        case 'Wavenumber (cm-1)': {
            return uvOrIR(meta, 'wavenumber');
        }
        case 'Nanometers (nm)':
            if ([/*'Kubelka-Monk'*/ 'Absorbance', 'Log(1/R)', 'Transmission'].includes(meta.yUnitsType)) {
                return uvOrIR(meta, 'nanometer');
            }
            return 'other';
        default:
            return 'other';
    }
}
/**
 * Further classify an X axis that is using "wavenumber" as uv or ir.
 * @param meta - the parsed file header.
 * @param xUnit - the unit of the X axis.
 * @returns the region classification.
 */
export function uvOrIR(meta, xUnit) {
    //tested in "parse" because of the input
    const dataShape = getDataShape(meta.parameters);
    //xyxy and exception won't normally get here anyways (raman or ms normally.)
    const analyze = ['Y', 'YY', 'XY', 'XYY'].includes(dataShape);
    if (analyze) {
        let sX = meta.startingX;
        let eX = meta.endingX;
        if (xUnit !== 'nanometer') {
            sX = unitToNano(sX, xUnit);
            eX = unitToNano(eX, xUnit);
        }
        const lowerBound = Math.min(sX, eX);
        return getRegion(lowerBound);
    }
    return 'other';
}
/**
 * Determines the spectral region from a wavelength boundary.
 * @param lb - lower boundary in nanometers.
 * @returns type of spectra.
 */
export function getRegion(lb) {
    return lb < 150 ? 'other' : lb < 700 ? 'uv' : 'ir';
}
/**
 * Converts micrometers or wavenumber units to nanometers
 * This allows a unique way to determine the spectra region (using nanometers).
 * @param x - value
 * @param from - input unit to convert
 * @returns equivalent in nanometers
 */
export function unitToNano(x, from) {
    return from === 'micrometer' ? x * 1000 : (1 / x) * 10 ** 7;
}
//# sourceMappingURL=guessSpectraType.js.map